<template>
  <p>{{ location }}</p>
</template>

<script>
export default {
  name: 'CellRendererLocation',
  computed: {
    location () {
      return this.params.value ? `${this.params.value.lat}, ${this.params.value.lng}` : 'N/A'
    }
  }
}
</script>
